import * as React from 'react';
import { Popper } from '@mui/base/Popper';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import Box from '@mui/joy/Box';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import Person from '@mui/icons-material/Person';
import Apps from '@mui/icons-material/Apps';
import FactCheck from '@mui/icons-material/FactCheck';
import Button from '@mui/joy/Button';
import Menu from '@mui/joy/Menu';
import MenuItem from '@mui/joy/MenuItem';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';

const NavigationMenu = React.forwardRef(({ focusNext, focusPrevious, menuOptions, ...props }, ref) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  
  const open = Boolean(anchorEl);
  const id = open ? 'about-popper' : undefined;
  return (
    <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
      <div onMouseLeave={() => setAnchorEl(null)}>
      <Button
          variant="plain"
          color="neutral"
          size="sm"
          aria-haspopup
          aria-expanded={open ? 'true' : 'false'}
          ref={ref}
          {...props}
          role="menuitem"
          onFocus={(event) => setAnchorEl(event.currentTarget)}
          onMouseEnter={(event) => {
            props.onMouseEnter?.(event);
            setAnchorEl(event.currentTarget);
          }}
         
          sx={[open && ((theme) => theme.variants.plainHover.neutral)]}
        >
          Menu <KeyboardArrowDown />
        </Button>  

        
        <Popper id={id} open={open} anchorEl={anchorEl} placement="bottom-start" disablePortal keepMounted>
          <List
            role="menu"
            aria-label="About"
            variant="outlined"
            sx={{
              my: 0.5,
              boxShadow: 'md',
              borderRadius: 'sm',
              '--List-radius': '4px',
              '--List-padding': '8px',
              '--ListDivider-gap': '4px',
              '--ListItemDecorator-size': '32px',
              backgroundColor: 'background.body',
              fontSize: '14px',
            }}
          >
             {menuOptions?.map((option, index) => (
              
              <ListItem key={option.name || index} role="none" sx={{
                '--ListItem-gap': '4px',
              }}>
                <ListItemButton role="menuitem" onClick={option.callback}>
                  {option.name}
                </ListItemButton>
              </ListItem>
            ))}

          </List>
        </Popper>
      </div>
    </ClickAwayListener>
  );
});


export default function NavigationDropdown({ menuOptions }) {
  return (   
          <NavigationMenu menuOptions={menuOptions} /> 
  );
}
